<template>
  <div>
    <v-divider></v-divider>

    <v-list
      subheader
      two-line
    >
      <v-subheader>{{ inputName }}</v-subheader>
      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <image-file-input-viewer
          class="mt-2"
          maxHeight="150"
          label="Section BG image"
          v-model="sectionData.bg_thumbnail"
          :clearable="true"
        />

        <v-checkbox
          label="Hide BG Image"
          v-show="sectionData.bg_thumbnail"
          v-model="sectionData.hide_bg_image"
        />

        <color-picker
          label="Section BG color"
          v-bind:color.sync="sectionData.bg_color"
        />
      </v-list-item-group>
    </v-list>

    <v-divider></v-divider>

    <v-list
      flat
      subheader
    >
      <v-subheader>Content</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <v-expansion-panels
          accordion
          class="mb-5"
        >
          <v-expansion-panel
            :key="i"
            v-for="(item, i) in sectionData[sectionData.type]"
            :class="{ 'section-has-error' : hasError(i)}"
          >
            <v-expansion-panel-header>{{ inputName }} {{ i + 1 }} </v-expansion-panel-header>
            <v-expansion-panel-content class="pb-4">
              <v-card
                shaped
                class="withdrawal-options"
              >
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                      class="px-5"
                    >
                      <normal-content-editor
                        v-model="sectionData[sectionData.type][i].description"
                        editorHeight="200"
                        label="How to item"
                        :errorMessages="descriptionError(head(errorMessages['page_sections.'+ currIndex + '.' + sectionData.type + '.' + i + '.description' ]))"
                      />

                      <image-file-input-viewer
                        class="mt-6"
                        maxHeight="150"
                        label="How To thumbnail"
                        v-model="sectionData[sectionData.type][i].thumbnail"
                        :clearable="true"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="removeFAQ(i)"
                    color="red"
                    class="mr-3"
                    small
                    icon
                  >
                    <v-icon
                      small
                      color="red"
                    >mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-btn
          v-if="sectionData[sectionData.type].length < 3"
          @click="addFAQ"
          class="green accent-4 white--text text-caption font-weight-bold header-btns"
        >Add Item
        </v-btn>
      </v-list-item-group>
    </v-list>
    <!--
    <div class="d-flex flex-row justify-space-between">
      <label class="d-block pb-3 pt-2 mt-4 grey--text">{{ inputName }}</label>
    </div>

    <image-file-input-viewer
      class="mt-4"
      maxHeight="150"
      label="Section BG image"
      v-model="sectionData.bg_thumbnail"
      :clearable="true"
    />

    <color-picker
      label="Section BG color"
      v-bind:color.sync="sectionData.bg_color"
    />

    <v-card
      class="withdrawal-options mb-3"
      :key="i"
      v-for="(item, i) in sectionData[sectionData.type]"
    >
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <normal-content-editor
              v-model="sectionData[sectionData.type][i].description"
              editorHeight="200"
              label="How to item"
            />

            <image-file-input-viewer
              class="mt-6"
              maxHeight="150"
              label="How To thumbnail"
              v-model="sectionData[sectionData.type][i].thumbnail"
              :clearable="true"
            />

          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <b
          @click="removeFAQ(i)"
          class="text-caption font-weight-bold header-btns"
        >remove</b>
      </v-card-actions>
    </v-card> -->
  </div>
</template>

<script>
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import NormalContentEditor from '@/components/NormalContentEditor'
import ColorPicker from '@/components/ColorPicker'
import head from 'lodash/head'

export default {
  name: 'PageHowTo',
  components: {
    ImageFileInputViewer,
    NormalContentEditor,
    ColorPicker
  },
  props: {
    sectionData: {
      type: Object,
      default () {
        return null
      }
    },
    inputName: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    },
    currIndex: {
      type: [String, Number],
      default: null
    },
    removedSections: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    head,
    addFAQ () {
      this.sectionData[this.sectionData.type].push(
        {
          title: null,
          description: null,
          thumbnail: null,
          thumbnail_mobile: null
        }
      )
    },
    removeFAQ (i) {
      if (this.sectionData[this.sectionData.type][i].id) {
        this.removedSections.push({
          type: this.sectionData.type,
          id: this.sectionData[this.sectionData.type][i].id
        })
      }
      this.sectionData[this.sectionData.type].splice(i, 1)
    },
    descriptionError (errorString) {
      if (errorString) {
        return 'How To description is required'
      } else {
        return null
      }
    },

    hasError (i) {
      return head(this.errorMessages['page_sections.' + this.currIndex + '.' + this.sectionData.type + '.' + i + '.description'])
    }

  }

}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}

.section-has-error {
  border-color: var(--v-error-base) !important;
  border-width: 2px;
  border-style: solid;
}
</style>
